package com.tfc.care.tfccare.utils


sealed class ApiResult<out T> {
    data class Success<T>(val data: T) : ApiResult<T>()
    data class Error(val exception: Throwable) : ApiResult<Nothing>()
    object Loading : ApiResult<Nothing>()
}

inline fun <T> runCatchingResult(block: () -> T): ApiResult<T> {
    return try {
        ApiResult.Success(block())
    } catch (e: Exception) {
        ApiResult.Error(e)
    }
}

suspend inline fun <T> runCatchingSuspend(crossinline block: suspend () -> T): ApiResult<T> {
    return try {
        ApiResult.Success(block())
    } catch (e: Exception) {
        Logger.e(e.message ?: "Unknown error in runCatchingSuspend", e)
        ApiResult.Error(e)
    }
}
